import { styled } from "utils";

const StyledButton = styled("button", {
  outline: "none",
  border: "none",
  cursor: "pointer",
  backgroundColor: "transparent",
  touchAction: "manipulation",
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  width: 36,
  height: 36,
  fill: "$grey100",
  "&:disabled": {
    cursor: "default",
    opacity: 0.3,
  },
});

type CarouselButtonProps = React.ComponentProps<typeof StyledButton>;

const NextButton: React.FC<CarouselButtonProps> = (props) => (
  <StyledButton css={{ right: "$4" }} {...props}>
    <svg viewBox="0 0 238.003 238.003">
      <path d="M181.776 107.719L78.705 4.648c-6.198-6.198-16.273-6.198-22.47 0s-6.198 16.273 0 22.47l91.883 91.883-91.883 91.883c-6.198 6.198-6.198 16.273 0 22.47s16.273 6.198 22.47 0l103.071-103.039a15.741 15.741 0 0 0 4.64-11.283c0-4.13-1.526-8.199-4.64-11.313z" />
    </svg>
  </StyledButton>
);
const PrevButton: React.FC<CarouselButtonProps> = (props) => (
  <NextButton
    css={{ left: "$4", transform: "translateY(-50%) rotate(180deg)" }}
    {...props}
  />
);

export { NextButton, PrevButton };
